import React, { useEffect, useState } from 'react';
import { Dropdown, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';

import {
    generateWeeklyReport
} from '../../services/reportService';
import { Loader } from '../../components/util/Svg';
import Breadcrumb from '../../components/Breadcrumb';
import { Form } from "react-bootstrap";


const Reports = () => {

    const breadcrumb = [
        { link: '', linkText: 'Reports' }
    ]

    const [reportType, setReportType] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [isGenerating, setIsGenerating] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [reportData, setReportData] = useState(null);

    const handleGenerateReport = async (e) => {
        e.preventDefault();

        if (!reportType) {
            alert("Please select a report type");
            return;
        }
        if (!startDate || !endDate) {
            alert("Please select both start and end dates");
            return;
        }
        if (new Date(startDate) > new Date(endDate)) {
            alert("Start date cannot be later than End date");
            return;
        }

        setIsGenerating(true);
        setIsLoading(true);
        setReportData(null);

        try {

            if (reportType == 'weekly') {
                const response = await getWeeklyReport()
            }else{
                alert("Comming Soon...");
            }

        } catch (err) {
            console.error(err);
            alert("Failed to generate report");
        } finally {
            setIsGenerating(false);
            setIsLoading(false);
        }
    };


    const getWeeklyReport = () => {
        const params = `?startDate=${startDate}&endDate=${endDate}&type=${reportType}`;

        generateWeeklyReport(params).then(res => {
            
            if (res.status) {
                console.log(res);
            }
        })
    }

    return (
        <div className="page_wrapper">
            <div className="search_bar">
                <h2 className="mb-0">Reports</h2>
            </div>

            <Breadcrumb breadcrumb={breadcrumb} />

            <div className="cm_card p-4 mb-3">
                <h5 className="mb-3">Generate Report</h5>
                <form onSubmit={handleGenerateReport}>
                    <div className="row">
                        {/* Report Type */}
                        <div className="col-md-4 mb-3">
                            <label className="form-label">Report Type</label>
                            <select
                                className="form-control rounded-pill"
                                value={reportType}
                                onChange={e => setReportType(e.target.value)}
                            >
                                <option value="">Select Report</option>
                                <option value="weekly">Weekly Report</option>
                                <option value="users">User Activity Report</option>
                                <option value="lux">Lux Report</option>
                                {/* add more types here */}
                            </select>
                        </div>

                        {/* Start Date */}
                        <div className="col-md-3 mb-3">
                            <label className="form-label">Start Date</label>
                            <input
                                type="date"
                                className="form-control rounded-pill"
                                value={startDate}
                                onChange={e => setStartDate(e.target.value)}
                            />
                        </div>

                        {/* End Date */}
                        <div className="col-md-3 mb-3">
                            <label className="form-label">End Date</label>
                            <input
                                type="date"
                                className="form-control rounded-pill"
                                value={endDate}
                                onChange={e => setEndDate(e.target.value)}
                            />
                        </div>

                        {/* Generate Button */}
                        <div className="col-md-2 d-flex align-items-end mb-3">
                            <button
                                type="submit"
                                disabled={isGenerating}
                                className="btn btn-primary w-100 rounded-pill"
                            >
                                {isGenerating ? "Generating..." : "Generate"}
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            {/* Loader / Report Results */}
            <div className="cm_card p-3">
                {isLoading ? (
                    <div className="loader_lg text-center"><Loader /></div>
                ) : reportData ? (
                    <div>
                        {/* Replace with your report rendering logic */}
                        <h5 className="mb-3">Report Result</h5>
                        <pre className="bg-light p-3 rounded">{JSON.stringify(reportData, null, 2)}</pre>
                    </div>
                ) : (
                    <p className="text-muted mb-0">No report generated yet.</p>
                )}
            </div>
        </div>
    );

}

export default Reports;